import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { AsPercentageExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/AsPercentageExpression";

export class AsPercentageExpressionEditor extends ExpressionRuleEditor<AsPercentageExpression> {
    render() {
        return (
            <ExpressionPiece>
                as percentage
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
